import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { GetReplacedUsers } from './_store/messages.actions';
import { MatDialog } from '@angular/material';
import { ComposeMessageComponent } from './compose-message/compose-message.component';
import { AppState } from 'src/app/app.reducer';
import { GetUserCapabilites, ClearAction } from 'src/app/login/store/auth.actions';
import { GetConfigurations } from "../configurations/store/configurations.actions";
import { Subject } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-user-users',
  templateUrl: './UserMessages.component.html',
  styleUrls: ['./UserMessages.component.scss']
})
export class UserMessagesComponent implements OnInit, OnDestroy {
  searchInput: FormControl = new FormControl();
  myMessagesClicked: boolean = true;
  replacedUsers: Array<any> = [];
  stopper$: Subject<any> =new Subject();

  constructor(
    private _store: Store<AppState>,
    private dialog: MatDialog,
    private ngxPermissionService: NgxPermissionsService,
  ) { }

  ngOnInit() {
    // this._store.dispatch(new ClearAction())
    // this._store.dispatch(new GetUserCapabilites());
    // this._store.dispatch(new GetConfigurations());
    // this._store.select(state => state.auth.user['capabilities']).pipe(takeUntil(this.stopper$)).subscribe(response => {
    //   if (response.length) {
        // let capabilities = response[0].capabilities;
        const capabilities = (Object.keys(this.ngxPermissionService.getPermissions()) || []);
        if (capabilities.includes("view-replace-user-messages")) {
          this._store.dispatch(new GetReplacedUsers());
          this._store.select(state => state.messages.replacedUsers).subscribe(response => {
            console.log(response);
            this.replacedUsers = response;
          });
        }
      }
    // });
  // }

  tabClick(type) {
    switch (type) {
      case 'my-messages':
        this.myMessagesClicked = true;
        break;
      case 'all-cmp-messages':
        this.myMessagesClicked = false;
        break;
      default:
        this.myMessagesClicked = false;
        break;
    }
  }

  launchMessage(messageType: string, msgIndex: number = -1, messageInfo: any = {}, tags?: any) {
    const dialogRef = this.dialog.open(ComposeMessageComponent, {
      width: '50%',
      panelClass: 'cmp-modal',
      data: {
        type: messageType,
        index: -1,
        info: messageInfo,
      },
      autoFocus: false
    });
  }

  ngOnDestroy() {
    this.stopper$.complete();
  }
}